import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';
import { FactureFournisseurDTO, Operateur } from '@/models/FactureFournisseurDTO';

export interface FilterFacturesFournisseur {
    page?: number;
    sort?: string;
    statut?: any;
    dateDebut?: string;
    dateFin?: string;
    societeIds?: number[];
    montant?: number;
    operateur?: Operateur;
    numero?: string;
    isHistorique?: boolean;
}

class FactureService {
    public async getFacturesFournisseur(params: FilterFacturesFournisseur): Promise<FactureFournisseurDTO[]> {
        return http.get(Routes.FactureFournisseurRoutes.RecupererFacturesFournisseur(), { params });
    }
    public async getFactureFournisseurById(id: number): Promise<FactureFournisseurDTO> {
        return http.get(Routes.FactureFournisseurRoutes.RecupererFactureFournisseur(id));
    }
    public async getFactureFournisseurRejeteeById(id: string): Promise<FactureFournisseurDTO> {
        return http.get(Routes.FactureFournisseurRoutes.RecupererFactureFournisseurRejetee(id));
    }

    public async contacter(factureId: string, objet: string, sujet: string): Promise<void> {
        return http.post(Routes.FactureFournisseurRoutes.Contacter(factureId), { objet: objet, sujet: sujet });
    }

    public async contacterComptaFournisseur(factureId: string, objet: string, sujet: string): Promise<void> {
        return http.post(Routes.FactureFournisseurRoutes.ContacterComptaFournisseur(factureId), {
            objet: objet,
            sujet: sujet,
        });
    }

    public async getFacturesXls(params: FilterFacturesFournisseur): Promise<any> {
        return http.get(Routes.FactureFournisseurRoutes.RecupererFacturesFournisseurXls(), {
            params,
            responseType: 'arraybuffer',
        });
    }
}

export default new FactureService();
